"use client"

import { useInView } from "react-intersection-observer"
import { Recycle, Users, Shield } from "lucide-react"
import "../assets/css/quality-sustainability.css"
import QualityImage from "../assets/images/quality1.webp"


export default function QualitySustainability() {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: true,
  })

  return (
    <section id="sustainability" ref={ref} className="quality-section">
      <div className="quality-container">
        <div className="section-header">
          <h2 className={`section-title ${inView ? "visible" : ""}`}>Quality & Sustainability</h2>
          <div className={`section-divider ${inView ? "visible" : ""}`}></div>
          <p className={`q-subtitle ${inView ? "visible" : ""}`}>
            Farming Smarter Growing Greener
          </p>
        </div>

        <div className="quality-grid">
          <div className={`quality-content ${inView ? "visible" : ""}`}>
            <h3 className="quality-title">Our Commitment to Excellence</h3>
            <p className="quality-description">
              At Green Beat Ceylon, we believe that true quality comes from a deep respect for nature and people. Our semi-greenhouses nurture Scotch Bonnet chilies in optimal conditions, using sustainable methods that protect the environment and ensure a consistent, premium harvest.
            </p>
            <p className="quality-description">
              Every chili is hand-picked by our dedicated local farmers, supporting rural livelihoods and strengthening our community. We are committed to transparency, traceability, and continuous improvement—so you can trust every product that bears our name.
            </p>

            <div className="quality-features">
              <div className="quality-feature">
                <div className="quality-feature-icon">
                  <Recycle className="icon-svg" />
                </div>
                <div className="quality-feature-content">
                  <h4 className="quality-feature-title">Sustainable Practices</h4>
                  <p className="quality-feature-description">
                    Eco-friendly farming that preserves natural resources and reduces our footprint.
                  </p>
                </div>
              </div>

              <div className="quality-feature">
                <div className="quality-feature-icon">
                  <Shield className="icon-svg" />
                </div>
                <div className="quality-feature-content">
                  <h4 className="quality-feature-title">Consistent Excellence</h4>
                  <p className="quality-feature-description">
                    Controlled environments for healthy plants and reliable, high-quality produce.
                  </p>
                </div>
              </div>

              <div className="quality-feature">
                <div className="quality-feature-icon">
                  <Users className="icon-svg" />
                </div>
                <div className="quality-feature-content">
                  <h4 className="quality-feature-title">Community First</h4>
                  <p className="quality-feature-description">
                    Empowering local farmers and building a brighter, greener future together.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className={`quality-image-container ${inView ? "visible" : ""}`}>
            <div className="quality-image">
              <img src={QualityImage} alt="Sustainable Farming" className="image" />
              <div className="image-overlay">
                <div className="overlay-content">
                  <p className="overlay-quote">"Farming Smarter – Growing Greener"</p>
                  <p className="overlay-author">– Green Beat Ceylon Pvt Ltd</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}